import { useQuery } from '@tanstack/react-query';
import type { SiestaSkillListItem } from '../types';

export default function useTenantSkills() {
  return useQuery<SiestaSkillListItem[]>({
    queryKey: ['tenant', 'custom-skills'],
  });
}
